module.exports = __webpack_public_path__ + "img/key-rent.e2c809db.svg";